import React, { useState } from "react";
import { IconButton, InputAdornment, OutlinedInput } from "@mui/material";
import { Field } from "formik";

import PasswordHidden from "assets/images/auth/password-hidden.svg";
import PasswordVisible from "assets/images/auth/password-visible.svg";

const PasswordInput = ({ id, name, testId }) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event) => {
    event.preventDefault();
  };

  return (
    <Field
      as={OutlinedInput}
      id={id}
      sx={{
        background: "white",
        borderRadius: "12px",
        height: "52px",
        transition: "all 0.3s ease",
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#d9d8df",
          borderWidth: "1.5px",
        },
        "&:hover:not(.Mui-focused)": {
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#d1d5db",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
          },
          transform: "translateY(-1px)",
        },
        "&.Mui-focused": {
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#01533b",
            borderWidth: "2px",
            boxShadow: "0 0 0 3px rgba(1, 83, 59, 0.1)",
          },
        },
      }}
      type={showPassword ? "text" : "password"}
      name={name}
      inputProps={{ "data-testid": testId }}
      endAdornment={
        <InputAdornment position="end">
          <IconButton
            size="small"
            aria-label={
              showPassword ? "hide the password" : "display the password"
            }
            onClick={handleClickShowPassword}
            onMouseDown={handleMouseDownPassword}
            onMouseUp={handleMouseUpPassword}
            edge="end"
          >
            {showPassword ? (
              <img src={PasswordHidden} alt="Password hidden" />
            ) : (
              <img src={PasswordVisible} alt="Password visible" />
            )}
          </IconButton>
        </InputAdornment>
      }
    />
  );
};

export { PasswordInput };
